import { render } from "./SubCategoryModal.vue?vue&type=template&id=44337038"
import script from "./SubCategoryModal.vue?vue&type=script&lang=js"
export * from "./SubCategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__